module.exports = __webpack_public_path__ + "static/media/go-to.e9076a57.svg";